export default __webpack_public_path__ + "static/media/home_back_mobile.4fb6e342.jpg";